import "./IconWorld.scss";
import { ReactComponent as WorldIcon } from "./svg/icon_world.svg";

type Props = {
  fill?: "white" | "blue";
};

export const IconWorld = ({ fill = "blue" }: Props) => {
  return (
    <span className={`IconWorld IconWorld__${fill}`}>
      <WorldIcon />
    </span>
  );
};
